import React from "react";
import styled from "styled-components";
import { Flex } from "components/atoms/Layout";
import { Input, CheckBox } from "components/atoms";
import Button from "components/atoms/Button";
import { COLOR_SYSTEM } from "components/design/design-system";
import Text from "components/atoms/Text";
import CommonHeader from "components/organisms/CommonHeader";

const Logo = styled.img`
  height: 32px;
`;

interface LoginTemplateProps {
  email: string;
  password: string;
  isLoading: boolean;
  emailError?: string;
  passwordError?: string;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onSignUp: () => void;
  onForgotPassword: () => void;
}

const LoginTemplate: React.FC<LoginTemplateProps> = ({
  email,
  password,
  isLoading,
  emailError,
  passwordError,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onSignUp,
  onForgotPassword,
}) => {
  return (
    <Container>
      <CommonHeader withoutPath={true} />
      <Main>
        <LoginForm onSubmit={onSubmit}>
          <FormContainer>
            <LogoSection>
              <Logo src="/images/logo.png" alt="약문약답 로고" />
              <Text textType="H1" color={COLOR_SYSTEM.get("Gray")[800]} style={{ marginBottom: 0 }}>
                PhAI
              </Text>
              <Text
                textType="Body2"
                color={COLOR_SYSTEM.get("Gray")[500]}
                style={{ marginTop: "0.25rem" }}
              >
                Pharmacist Assistant Intelligence
              </Text>
            </LogoSection>
            <Input
              type="email"
              label="이메일"
              placeholder="example@email.com"
              value={email}
              onChange={onEmailChange}
              error={!!emailError}
              hint={emailError}
              style={{ width: "100%" }}
            />
            <Input
              type="password"
              label="비밀번호"
              placeholder="비밀번호를 입력하세요"
              value={password}
              onChange={onPasswordChange}
              error={!!passwordError}
              hint={passwordError}
              style={{ width: "100%" }}
            />

            <Button
              buttonType="submit"
              type="Text"
              size="Large"
              variant="Contained"
              color="Primary"
              disabled={isLoading}
              style={{ width: "100%", marginTop: "20px" }}
            >
              로그인
            </Button>
            <OptionsContainer>
              <SignUpContainer>
                <Text textType="Body2" color={COLOR_SYSTEM.get("Gray")[600]}>
                  계정이 없으신가요?
                </Text>
                <button
                  type="button"
                  onClick={onSignUp}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                >
                  <Text element="span" textType="Body2" color={COLOR_SYSTEM.get("Blue")[500]}>
                    회원가입
                  </Text>
                </button>
              </SignUpContainer>
              {/* <button
                type="button"
                onClick={onForgotPassword}
                style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
              >
                <Text element="span" textType="Body2" color={COLOR_SYSTEM.get("Blue")[500]}>
                  비밀번호 찾기
                </Text>
              </button> */}
            </OptionsContainer>
          </FormContainer>
          <DescriptionSection>
            <Text
              textType="Caption"
              color={COLOR_SYSTEM.get("Gray")[500]}
              style={{ textAlign: "center", lineHeight: "1.5" }}
            >
              PhAI는 약사의 처방검토 업무를 지원하는 AI 기반 의사결정지원시스템입니다.<br />
            </Text>
          </DescriptionSection>
        </LoginForm>
      </Main>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background-color: ${COLOR_SYSTEM.get("Gray")[0]};
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoginForm = styled.form`
  width: 100%;
  max-width: 470px;
`;

const FormContainer = styled.div`
  background-color: ${COLOR_SYSTEM.get("Gray")[0]};
  border-radius: 1rem;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")[200]};
  padding: 3rem 2.5rem 2.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
  width: 100%;
  min-width: 470px;
  align-items: center;
`;

const LogoSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const OptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.5rem;
  min-height: 32px;
  width: 100%;
`;

const SignUpContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  margin-top: 1.5rem;
`;

const DescriptionSection = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default LoginTemplate;
